import React, { useEffect, useState } from 'react'
import style from './policy.module.sass'
import { Button } from '../../../helpers/commonUi/Button'
import search from '../../../assets/images/searchicon.png';
import { useRouteMatch } from 'react-router'
import { Http } from '../../../helpers/axois'
import { useToast } from '../../../helpers/commonFunction'

import { Checkbox } from 'antd'
import { useSelector } from 'react-redux';
import { AppState } from '../../../stateManager/store';

const CheckBoxGroup = Checkbox.Group

export const CreatePolicy = (props: any) => {

    const { params: { orgId } }: any = useRouteMatch()

    const [permissionsList, setPermissionsList] = useState<any>([])

    const [checkBoxValues, setCheckBoxValues] = useState<any>([])

    const [policyName, setPolicyName] = useState<string>('')
    const [policyDescription, setPolicyDescription] = useState<string>('')
    const { selectedOrg } = useSelector((state: AppState) => state.org)
    const loggedInUserId = useSelector((state: any) => {
        return state.user.data.user.id
    })
    const [permissionSearch, setPermissionSearch] = useState<string>('')

    const { ErrorToast, SuccessToast } = useToast()
    const orgPermissions: any = useSelector((state: any) => {
        return state.org.orgPermissions
      }, (oldPermissions: any, newPermissions: any) => JSON.stringify(oldPermissions) === JSON.stringify(newPermissions))
      
    useEffect(() => {
        if ((!orgPermissions?.includes("policy.View") || !orgPermissions.includes('org.View'))&&  loggedInUserId!=selectedOrg?.owner) {
            ErrorToast("Error fetching permissions")
            return
          } 
        Http.get(`/permissions?orgId=${orgId}`).subscribe((res: any) => {
            res.forEach((item: any) => {
                if (item.name.includes('bpmn')) {
                    item.name = item.name.replace('bpmn', 'journey')
                }
            })
            setPermissionsList(res)
        }, (e) => {
            if (e === "Forbidden") {
                ErrorToast("Error fetching permissions")
            } else {
                ErrorToast('Error fetching permissions')
            }
        })
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const policyTypes: string[] = ['org', 'theme', 'env', 'app', 'team', 'journey', 'dmn', 'forms', 'service', 'func', 'config', 'data', 'deploy', 'user', 'policy', 'dialog', 'content', 'nlu','audit','store','acl','branch','i18n','staticAsset',"marketplace", "aiAgent", 'dataModel']

    const groupedPermissionList: any[] = permissionsList.length > 0 ? policyTypes.map((policy: string) => {
            if (policy === 'dataModel') {
                return permissionsList.filter((permission: any) => permission.name.startsWith('dataModel'))
            } else if (policy === 'data'){
                return permissionsList.filter((permission: any) => permission.name.startsWith('data') && !permission.name.startsWith('dataModel'))
            } else {
                return permissionsList.filter((permission: any) => permission.name.startsWith(policy))
            }
    }) : []   

    const filteredPermissionList: any[] = (permissionsList.length > 0) ? permissionsList.filter((permission: any) => {
        return permission.name.toLowerCase().includes(permissionSearch)
    }) : []

    const createPolicy = () => {
        if (policyName === '') {
            ErrorToast('Please provide policy name')
        } else if (policyDescription === '') {
            ErrorToast('Please provide policy description')
        } else if (checkBoxValues.length === 0) {
            ErrorToast('Select atleast one permission')
        } else {
            Http.post('/policy', {
                name: policyName,
                orgId: orgId,
                description: policyDescription,
                permissionIds: checkBoxValues
            }).subscribe(() => {
                SuccessToast('Policy created successfully')
                props.getPolicy()
            }, () => {
                ErrorToast('Error creating policy')
            })
        }
    }

    return (
        <div className={style.createPolicyContainer}>
            <div className={style.header}>
                <div className={style.textContainer}>
                    <h3>Create Policy</h3>
                    <p>Add new policy permissions</p>
                </div>
                <Button dataTestId="create_policy" size="small" onClick={createPolicy}>CREATE POLICY</Button>
            </div>
            <div style={{ height: 'calc(100vh - 212px)', overflowY: 'auto' }}>
                <div className={style.inputsContainer}>
                    <div className={style.input}>
                        <div className={style.name}>Policy Name :</div>
                        <input data-test-id="policy_name" value={policyName} type='text' onChange={(e: any) => setPolicyName(e.target.value)}></input>
                    </div>
                    <div className={style.input}>
                        <div className={style.name}>Description :</div>
                        <input data-test-id="description" type='text' style={{ marginLeft: '8px' }} value={policyDescription} onChange={(e: any) => setPolicyDescription(e.target.value)}></input>
                    </div>
                </div>
                <h3 className={style.permissionTitle}>Policy Permission</h3>
                <div className={style.search} >
                    <img src={search} alt="" />
                    <input data-test-id="search" type="search" value={permissionSearch} onChange={(e: any) => setPermissionSearch(e.target.value)} placeholder="Search Permissions..." />
                </div>
                <div className={!permissionSearch ? 'override-checkbox-group' : 'override-checkbox-filtered-list'}>
                    {
                        !permissionSearch ?
                            groupedPermissionList.map((group, index) => {
                                const title = group[0] && group[0].name.split('.')[0]
                                return (
                                    <Group data-test-id={`${checkBoxValues}`} key={index} checkBoxValues={checkBoxValues} setCheckBoxValues={setCheckBoxValues} title={title} options={group} />
                                )
                            })
                            :
                            filteredPermissionList.map((permission) => {
                                const title = permission.name.toLowerCase()
                                return (
                                    <SingleBox data-test-id={`${checkBoxValues}`} key={permission.id_} id={permission.id_} checkBoxValues={checkBoxValues} setCheckBoxValues={setCheckBoxValues} title={title} />
                                )
                            })
                    }
                </div>
            </div>
        </div>
    )
}

const SingleBox = (props: any) => {

    const onChangeCheckBox = (e: any) => {
        const prevList: any[] = [...props.checkBoxValues]
        let finalList: any[] = []
        if (e.target.checked) {
            if (!prevList.includes(props.id)) {
                finalList = [...prevList, props.id]
            }
        } else {
            if (prevList.includes(props.id)) {
                finalList = prevList.filter((item: any) => item !== props.id)
            }
        }
        props.setCheckBoxValues(finalList)
    }

    const titleChecked = props.checkBoxValues.includes(props.id)

    return (
        <Checkbox data-test-id="title_checked" checked={titleChecked} onChange={onChangeCheckBox}>{props.title}</Checkbox>
    )
}

const Group = (props: any) => {
    let options = props.options.map((option: any) => {
        return {
            label: option.name.toLowerCase(),
            value: option.id_
        }
    })
    const groupValues = options.map((option: any) => option.value)

    //Checking present values on initial load
    const presentValues = props.checkBoxValues.filter((item: any) => groupValues.includes(item))
    const allValuesPresent = groupValues.length === presentValues.length
    const noValuesPresent = presentValues.length === 0

    const [indeterminate, setIndeterminate] = useState<boolean>(!allValuesPresent && !noValuesPresent)
    const [titleChecked, setTitleChecked] = useState<boolean>(allValuesPresent)

    const onGroupChange = (list: any[]) => {

        const prevList = [...props.checkBoxValues]
        const absentList = groupValues.filter((value: any) => !list.includes(value))

        list.forEach(value => {
            if (!prevList.includes(value)) {
                prevList.push(value)
            }
        })
        const finalList = prevList.filter((value: any) => !absentList.includes(value))
        props.setCheckBoxValues(finalList)

        if (list.length === options.length) {
            setIndeterminate(false)
            setTitleChecked(true)
        } else if (list.length === 0) {
            setIndeterminate(false)
            setTitleChecked(false)
        } else {
            setIndeterminate(true)
            setTitleChecked(false)
        }
    }

    const onTitleChange = (e: any) => {
        if (e.target.checked || indeterminate) {
            setTitleChecked(true)
            setIndeterminate(false)
            const newList = [...props.checkBoxValues]
            groupValues.forEach((value: any) => {
                if (!newList.includes(value)) {
                    newList.push(value)
                }
            })
            props.setCheckBoxValues(newList)
        } else {
            setTitleChecked(e.target.checked)
            const newList = props.checkBoxValues.filter((value: any) => !groupValues.includes(value))
            props.setCheckBoxValues(newList)
        }
    }

    return (
        <div style={{ padding: '0 0 30px 30px', minWidth: '250px' }}>
            <Checkbox data-test-id="title_checked" checked={titleChecked} indeterminate={indeterminate} onChange={onTitleChange}>{props?.title?.toUpperCase()}</Checkbox>
            <CheckBoxGroup data-test-id="options" style={{ display: 'flex', flexDirection: 'column', 'width': 'fit-content' }} value={props.checkBoxValues} options={options} onChange={onGroupChange} />
        </div>
    )
}